<template>
    <b-modal
        :id="modalId"
        size="xl"
        hide-footer
        body-class="overflow-auto"
        centered
        :title="$t('availability')"
        @hidden="handleHidden()"
    >
        <EChart :options="chartData" card class="shadow-none m-0" />
    </b-modal>
</template>



<script>
    import EChart from '@/components/common/EChart.vue';

    export default {
        name: 'ModalAvailabilityInStoresItem',
        components: {
            EChart,
        },
        data() {
            return {
                modalId: 'ModalAvailabilityInStoresItem',
                item: null,
            };
        },
        computed: {
            chartData() {
                const perShop = this.item?.allPriceOccurrences;
                if (!perShop || Object.keys(perShop).length === 0) {
                    return { series: [] };
                }

                // 1) Oś Y: same etykiety sklepów
                const shopLabels = Object.keys(perShop);

                // 2) Zbuduj apexData: jeden “wiersz” na sklep z tablicą segmentów
                const apexData = shopLabels.map(shopName => {
                    const segments = (perShop[shopName] || [])
                        .map(seg => {
                            const startTs = Number(seg?.start);
                            const endTs = Number(seg?.end);
                            if (!Number.isFinite(startTs) || !Number.isFinite(endTs) || startTs > endTs) return null;
                            return { x: shopName, y: [startTs, endTs] };
                        })
                        .filter(Boolean);

                    return { name: shopName, data: segments };
                });

                // 3) Seria rangeBar zgodnie z oczekiwaniem EChart (jeden element data z polem data:[])
                const series = apexData.map(row => ({
                    name: row.name,
                    type: 'rangeBar',
                    data: [row],
                }));

                return {
                    xAxis: { type: 'time' },
                    yAxis: {
                        type: 'category',
                        data: shopLabels, // proste etykiety
                    },
                    series,
                };
            },
        },
        methods: {
            initItem(item) {
                this.item = item;
            },
            handleHidden() {
                this.item = null;
            },
        },
        mounted() {
            this.$root.$on(this.modalId, this.initItem);
        },
        beforeDestroy() {
            this.$root.$off(this.modalId, this.initItem);
        },
    };
</script>
